export const appId = 'org.openedx.frontend.app.instructorDashboard';
export const instructorDashboardRole = 'org.openedx.frontend.role.instructorDashboard';

// Slot rendered in place of the enrollment action buttons (Enroll Learners / Add Beta Testers).
// The default widget renders the buttons for everyone; a deployment can REPLACE or REMOVE it via
// site.config to change which buttons appear and who may use them.
export const enrollmentActionsSlotId = 'org.openedx.frontend.slot.instructorDashboard.enrollmentActions.v1';
export const enrollmentActionsWidgetId = 'org.openedx.frontend.widget.instructorDashboard.enrollmentActions.default';
